


























import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconLogout from "@/common/components/icons/IconLogout.vue";

import { Vue, Component, Prop } from "vue-property-decorator";

import commons from "@/common/store/modules/commons";

import { karteLogin } from "@/common/assets/js/karte/";
import LocalStorage from "@/general/utils/storage";
import AuthApi from "@/general/api/authApi";
import loginInfo from "@/general/store/modules/loginInfo";
import auth from "@/general/store/modules/auth";


@Component({
  components: {
    IconUserImage,
    IconBase,
    IconLogout
  }
})
export default class TheHeaderNaviProfilePanel extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) ssoFlg!: boolean;
  avatar = "";

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return commons?.colorCode;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get userName() {
    return commons.getNameFromUser(commons.userInfo);
  }

  get userAvatar() {
    //#59042対応によりセッション情報からavatarを取得するように修正
    //return commons.userInfo?.avatar;
    return this.avatar;
  }

  async logout() {
    karteLogin(false);

    await fetch(commons.LOGOUT_URL, { method: "POST" })
      .then(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        AuthApi.getLogout().catch((e) => {
          console.log(e);
        });
        auth.remove();
        if (this.ssoFlg) {
          // SSOログインの場合は行き止まりログアウトへ遷移
          window.location.href = "/logout/";
        } else {
          window.location.href =
            process.env.VUE_APP_API_DOMAIN + "/v1/top/login";
        }
      })
      .catch(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        AuthApi.getLogout().catch((e) => {
          console.log(e);
        });
        auth.remove();
        if (this.ssoFlg) {
          // SSOログインの場合は行き止まりログアウトへ遷移
          window.location.href = "/logout/";
        } else {
          window.location.href =
            process.env.VUE_APP_API_DOMAIN + "/v1/top/login";
        }
      });
  }

  //#59042対応によりセッション情報からavatarを取得するように修正
  async created() {
    this.ssoFlg = loginInfo.isSso;
    await AuthApi.getICSession()
      .then((result) => {
        const ic_session = JSON.parse(result);
        this.avatar = ic_session.avatar;
      })
      .catch(() => {
        this.avatar = "";
      });
  }
}
